import { Component } from '@angular/core';
import { I18nStrType } from '@app/i18n/i18n.types';
import { TranslateService } from '@ngx-translate/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get, isArray, isString, map } from 'lodash';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-prepared-string-renderer',
  template: '{{value}}',
})
export class XVIPreparedStringRendererComponent implements AgRendererComponent {
  public value: string;

  public constructor(private transferService: TranslateService) {}

  public agInit(params: ICellRendererParams): void {
    let value: string = get(params, 'value', '');
    const handler: Function = get(
      params,
      'stringHandlerFn',
      get(params, 'colDef.cellRendererParams.stringHandlerFn', null),
    );
    const skipTranslations: boolean = get(
      params,
      'skipTranslations',
      get(params, 'colDef.cellRendererParams.skipTranslations', false),
    );
    const valueToEnumMap: Record<string, I18nStrType> = get(
      params,
      'valueToEnumMap',
      get(params, 'colDef.cellRendererParams.valueToEnumMap', null),
    );

    if (isArray(value)) {
      const skipTranslationsForArray: boolean = get(
        params,
        'skipTranslationsForArray',
        get(params, 'colDef.cellRendererParams.skipTranslationsForArray', true),
      );
      this.value = this.getHandledValue(
        handler,
        map(value, (valueItem) =>
          this.transferService.instant(
            get(valueToEnumMap, valueItem, valueItem),
          ),
        ),
        skipTranslationsForArray,
      );

      return;
    }

    const valueFormatted = get(params, 'valueFormatted');
    value = isString(valueFormatted) ? valueFormatted : value;
    this.value = this.getHandledValue(
      handler,
      get(valueToEnumMap, value, value),
      skipTranslations,
    );
  }

  public refresh(): boolean {
    return true;
  }

  private getHandledValue(
    handler: Function,
    value: string | I18nStrType | string[] | I18nStrType[],
    skipTranslation: boolean = false,
  ): string {
    const handledValue: string = handler
      ? handler(value, this.transferService)
      : value;
    /* eslint-disable-next-line */
    return skipTranslation
      ? handledValue
      : this.transferService.instant(handledValue as I18nStrType);
  }
}
